export enum FormFieldType {
  INSTRUCTION = 'instruction',

  TEXT = 'text',
  SHORT_TEXT = TEXT, // alias

  TEXTAREA = 'textarea',
  EMAIL = 'email',
  PASSWORD = 'password',
  TABLE = 'table',
  DATE = 'date',
  DATETIME = 'datetime',
  SIGNATURE = 'signature',
  NUMBER = 'number',
  CHECKBOX = 'checkbox',
  CURRENCY = 'currency',
  FILE_UPLOAD = 'fileupload',
  TASK_LIST = 'tasklist',
  MULTISELECT_LIST = 'multiselectlist',
  APPROVAL_RULE = 'approvalrule',

  RADIO_BUTTON_LIST = 'radiobuttonlist', // Option list
  OPTIONLIST = RADIO_BUTTON_LIST, // alias

  SELECT_LIST = 'selectlist', // Dropdown list
  DROPDOWN_LIST = SELECT_LIST, // alias
  LOOKUP = 'lookup',

  FORMULA = 'formula',
  ADDRESS = 'address',
  APPROVAL_COMMENT = 'approvalcomment',
  ATTACH_DOCUMENT = 'attachdocument',
  IMAGE = 'image',
  RECAPTCHA = 'recaptcha',
  PROCEDURE = 'procedure',
  EXTERNAL_BUSINESS = 'externalbusiness'
}
